export default __webpack_public_path__ + "static/media/regulatory--pedestrians-push-button--g1.4e8319dc.png";